module.exports = __webpack_public_path__ + "media/images/front/icon_drvideo-76baa390c1d8071fb4cb99af6bf8150b.png";